import React from 'react';
import { BaseAlertBanner } from '@components';
import { UploadStateInfo } from '@components/image-upload-modal/styled.tsx';

interface Props {
    fileName: string;
    fileSize: string;
    message: string;
}

export const PhotoUploadSuccess: React.FC<Props> = ({ fileName, fileSize, message }) => {
    return (
        <BaseAlertBanner
            type={'success'}
            title={message}
            description={
                <UploadStateInfo>
                    {fileName} ({fileSize} MB)
                </UploadStateInfo>
            }
        />
    );
};
